export default __webpack_public_path__ + "static/media/Leases.fa79d019.svg";